var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgScheduleTime(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "schedule",
    clipPath: "url(#clip0_5762_33109)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M6.99547 1.16602C3.77547 1.16602 1.16797 3.77935 1.16797 6.99935C1.16797 10.2193 3.77547 12.8327 6.99547 12.8327C10.2213 12.8327 12.8346 10.2193 12.8346 6.99935C12.8346 3.77935 10.2213 1.16602 6.99547 1.16602ZM7.0013 11.666C4.42297 11.666 2.33464 9.57768 2.33464 6.99935C2.33464 4.42102 4.42297 2.33268 7.0013 2.33268C9.57964 2.33268 11.668 4.42102 11.668 6.99935C11.668 9.57768 9.57964 11.666 7.0013 11.666ZM7.29297 4.08268H6.41797V7.58268L9.48047 9.42018L9.91797 8.70268L7.29297 7.14518V4.08268Z",
    fill: "#4B5C68"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5762_33109"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScheduleTime);
export default __webpack_public_path__ + "static/media/scheduleTime.828ac97b29931dd515cdb81760ee58dc.svg";
export { ForwardRef as ReactComponent };